module.exports = "/images/fa5bfc44aec08754dad470e1dec91d63.jpg";